<template>
  <div class="tooltip-wrapper">
    <div v-show="visible" class="tooltip-content" :style="tooltipContentStyle">
      <slot name="title">{{ text }}</slot>
    </div>
    <div @click.stop="onShowTooltip" :style="contentWrapperStyle || ''">
      <slot>
        <img class="icon" src="@/assets/icon/hint.svg" alt="">
      </slot>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, onUnmounted, ref } from 'vue'
export default defineComponent({
  props: {
    text: String,
    disable: Boolean,
    contentWrapperStyle: String,
    tooltipContentStyle: String
  },
  emits: ['update:visible'],
  setup (props) {
    const visible = ref(false)
    const onShowTooltip = () => {
      if (props.disable) return
      visible.value = true
    }
    const hideTooltip = () => {
      visible.value = false
    }
    onMounted(() => {
      const body = document.body
      if (body) {
        body.addEventListener('click', hideTooltip, {
          capture: true
        })
      }
    })
    onUnmounted(() => {
      const body = document.body
      if (body) {
        body.removeEventListener('click', hideTooltip)
      }
    })
    return {
      visible,
      onShowTooltip
    }
  }
})
</script>

<style lang="less" scoped>
.tooltip-wrapper {
  position: relative;
  .tooltip-content {
    max-width: 27.3rem;
    width: fit-content;
    border-radius: 0.8rem;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    // top: -10px;
    // bottom: 3.4rem;
    bottom: calc(100% + 1.2rem);
    padding: 1.2rem 1.6rem;
    background: #FFFFFF;
    box-shadow: 0px 0px 12px 0px rgba(0,0,0,0.16);
    font-size: 1.4rem;
    color: #333;
    z-index: 100;
    &::after {
      content: '';
      display: inline-block;
      position: absolute;
      bottom: -1rem;
      left: 50%;
      transform: translateX(-50%);
      // width: 3rem;
      border: 0.6rem solid #fff;
      border-left-color: transparent;
      border-right-color: transparent;
      border-bottom-color: transparent;
    }
  }
}
</style>
